import { createReducer } from '@reduxjs/toolkit';
import { LoadingStatuses } from '@packages/shared/core/common/entities';
import {
  submitSupportFormPending,
  submitSupportFormSucceed,
  submitSupportFormFailed,
  resetSupportFormStatus,
} from './actions';
import { supportInitialState } from './state';

export const supportReducer = createReducer(supportInitialState, (builder) => {
  builder
    .addCase(submitSupportFormPending, (state) => {
      state.submitStatus = LoadingStatuses.PENDING;
      state.error = null;
    })
    .addCase(submitSupportFormSucceed, (state) => {
      state.submitStatus = LoadingStatuses.FULFILLED;
      state.error = null;
    })
    .addCase(submitSupportFormFailed, (state, { payload }) => {
      state.submitStatus = LoadingStatuses.FAILED;
      state.error = payload;
    })
    .addCase(resetSupportFormStatus, (state) => {
      state.submitStatus = LoadingStatuses.IDLE;
      state.error = null;
    });
});
